import React from 'react';
import ContactForm from '../components/ContactForm';
import Accordion from '../components/Accordion';

function Contact() {
    const accordionItems = [
        {
            id: 'Q1',
            title: 'What kind of events do you organize?',
            description:
                'We specialize in weddings, social gatherings, and corporate events. We take care of all the organization, catering, location, guests and everything in between so you can have a memorable day!',
        },
        {
            id: 'Q2',
            title: 'Can I change the date of my booking??',
            description:
                'We specialize in weddings, social gatherings, and corporate events. We take care of all the organization, catering, location, guests and everything in between so you can have a memorable day!',
        },
        {
            id: 'Q3',
            title: 'Can I cancel my booking?',
            description:
                'We specialize in weddings, social gatherings, and corporate events. We take care of all the organization, catering, location, guests and everything in between so you can have a memorable day!',
        },
    ];

    return (
        <>
            <div className="page__width flex flex-col lg:flex-row gap-8 lg:gap-0 items-start justify-between my-16">
                <div className="w-full lg:w-2/5 flex flex-col items-start gap-2 lg:gap-4">
                    <h3 className="text-xl lg:text-2xl text-white">
                        Contact details
                    </h3>
                    <p className="w-full text-text text-base lg:text-lg ">
                        25 Thurso House, Randolph Gardens, NW65EL <br />
                        London, United Kingdom
                    </p>
                    <a
                        href="mailto:mariyan.alekov@smoothaffairs.co.uk"
                        target="_blank"
                        rel="noreferrer"
                        className="w-full text-brand underline text-base lg:text-lg ">
                        mariyan.alekov@smoothaffairs.co.uk
                    </a>
                    <p className="w-full text-text text-base lg:text-lg ">
                        +44 748 022 99 43
                    </p>
                </div>
                <div className="w-full lg:w-3/5 flex flex-col items-start">
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start text-white">
                        Contact Us
                    </h2>
                    <ContactForm />
                </div>
            </div>
            <div className="w-full bg-secondary py-20">
                <div className="page__width flex flex-col items-center">
                    <h2 className="text-3xl lg:text-5xl text-center lg:text-start mb-4 text-white">
                        FAQs
                    </h2>
                    <Accordion accordionItems={accordionItems} />
                </div>
            </div>
        </>
    );
}

export default Contact;
